import React, {Component} from 'react';
import {Link, withRouter} from "react-router-dom";
import {IMAGE_URL} from "../../config/Config";
import {connect} from "react-redux";
import {Button} from "reactstrap";
import {logoutUser} from "../../redux/actions/user";

class UserPanelMenu extends Component {
    render() {
        const {activeElement,user} = this.props;
        const AuthButton = withRouter(
            ({ history }) =>
                <a href=""  onClick={() => {
                    this.props.logoutUser(() => {
                        history.push("/login");
                    });
                }}><i className="la la-sign-out"/>  خروج</a>
        );

        return (
            <div className="panel panel-default sidebar-menu white">
             {/*<div className="panel-heading">
                    <h3 className="panel-title">بخش های کاربر</h3>
                </div>*/}
                <div className="panel-body">
                    <div className='white p-3 border border-light'>
                        <div className="p-3">
                            <img src={IMAGE_URL + user.pic} className="img-fluid rounded-circle z-depth-0 " alt={user.firstName+" "+user.lastName}/>
                            <br/>
                            <h5 className="text-center text-muted mt-3">{user.firstName+" "+user.lastName}</h5>
                            <div className="text-center mb-3">
                                <Button color="danger"  className="user-massage-btn">پیام های من</Button>
                            </div>
                        </div>
                    </div>

                    <ul className="nav nav-pills nav-stacked">
                        <li className={(activeElement==="1") ? "active" : ""} >
                            <Link to="/users"><i className="la la-dashboard "></i> صفحه کاربری</Link>
                        </li>
                        <li className={(activeElement === "2") ? "active" : ""}>
                            <Link to="/profile"><i className="la la-user  "></i> پروفایل </Link>
                        </li>
                        <li className={(activeElement==="3") ? "active" : ""} >
                            <Link to="/my-jobs"><i className="la la-building"></i> کسب و کارهای من</Link>
                        </li>
                        <li className={(activeElement==="4") ? "active" : ""} >
                            <Link to="/new-job"><i className="la la-plus"></i>  ایجاد کسب و کار</Link>
                        </li>
              {/*          <li className={(activeElement==="5") ? "active" : ""} >
                            <Link to="/refer-to-friend"><i className="la  la-users"></i> معرفی به دوستان</Link>
                        </li>*/}
                        <li>
                           {/* <Link to="/users"><i className="la la-sign-out"></i>خروج</Link>*/}
                            <AuthButton />
                        </li>
                    </ul>
                </div>
            </div>

        );
    }
}


const mapStateToProps = (state) => {
    return {
        user : state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        logoutUser : (cb) => {
            dispatch(logoutUser(), setTimeout(cb,0))
        }
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(UserPanelMenu);


// WEBPACK FOOTER //
// ./src/components/user/UserPanelMenu.js